/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  fetchData,
  postData,
  deleteData,
  putData,
} from "@jda/lui-portal-utilities";
import { createRequestObject, getAuthToken } from "../utility/commonUtility";
import {
  IGetOrganizationPayload,
  organizationRequest,
} from "../models/Organizations/OrganizationContracts";

const { MANAGEMENT_SERVICE_URL } = window.env;

export const getAllOrganizations = async (payload: IGetOrganizationPayload) => {
  const { pageNo, pageSize, searchString } = payload;
  let apiURL = `${MANAGEMENT_SERVICE_URL}/organizations?page-number=${
    pageNo || 1
  }&page-size=${pageSize || 50}`;
  apiURL = searchString ? `${apiURL}&filter-name=${searchString}` : apiURL;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationById = async (id: number) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/` + id;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewOrganization = async (data: organizationRequest) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations`;
  return postData<any>(
    createRequestObject(apiURL),
    { name: data.name },
    getAuthToken
  )
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteOrganization = async (id: string) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/` + id;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateOrganization = async (data: organizationRequest) => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/` + data.id;
  return putData<any>(
    createRequestObject(apiURL),
    { name: data.name },
    getAuthToken
  )
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};
